import { render } from "./nyirbilar.vue?vue&type=template&id=09497222"
import script from "./nyirbilar.vue?vue&type=script&lang=js"
export * from "./nyirbilar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__